class ProductChart extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setClipPath = this.setClipPath.bind(this)

    window.addEventListener('resize', this.setClipPath)
    this.setClipPath()

    this.onChartShow = this.onChartShow.bind(this)
    this.listeners.add(document, 'chartVisible', this.onChartShow)
  }

  setupListeners () {
    super.setupListeners()

    this.onLabelEnter = this.onLabelEnter.bind(this)

    this.els.label.elements.forEach((el) => {
      this.listeners.add(el, 'mouseenter', this.onLabelEnter)
    })

    this.externalEls.label.elements.forEach((el) => {
      this.listeners.add(el, 'mouseenter', this.onLabelEnter)
    })
  }

  onChartShow () {
    if (this.classList.contains('prd-Chart-shown')) return

    if (!this.classList.contains('prd-Chart-shown')) {
      this.sendGA4Event()
    }

    const addVisibleAndActiveClass = (elements) => {
      elements.forEach((label, index) => {
        const delay = (index + 1) * 600

        setTimeout(() => {
          label.classList.add(label.dataset.activeClass)
          label.classList.add(label.dataset.visibleClass)

          setTimeout(() => {
            label.classList.add(label.dataset.loadedClass)

            // If it's not the last label, remove the activeClass after 600ms
            if (index !== elements.length - 1) {
              label.classList.remove(label.dataset.activeClass)
            }
          }, 600)
        }, delay)
      })
    }

    const { elements: internalLabels } = this.els.label || {}
    const { elements: externalLabels } = this.externalEls.label || {}

    const reversedInternalLabels = internalLabels.slice().reverse()

    const totalLabels = internalLabels?.length || 0
    const totalDelay = totalLabels * 600

    // Start the process of adding visible and active classes
    setTimeout(() => {
      addVisibleAndActiveClass(reversedInternalLabels)
      addVisibleAndActiveClass(externalLabels)
    }, 600)

    // Delay adding 'prd-Chart-loaded' class until after all labels are processed
    setTimeout(() => {
      this.classList.add('prd-Chart-loaded')
    }, 600 + totalDelay)

    this.classList.add('prd-Chart-shown')
  }

  onLabelEnter (e) {
    // Prevent mouseenter event if 'prd-Chart-loaded' class is not present
    if (!this.classList.contains('prd-Chart-loaded')) return

    const label = e.target.dataset.label

    const toggleClass = (elements) => {
      elements?.forEach((el) => {
        el.classList.toggle(el.dataset.activeClass, el.dataset.label === label)
      })
    }

    const { elements: internalElements } = this.els.label || {}
    const { elements: externalElements } = this.externalEls.label || {}

    toggleClass(internalElements)
    toggleClass(externalElements)
  }

  sendGA4Event () {
    const ga4EventData = {
      event: 'product_chart_viewed',
      chart: {
        page_type: this.dataset.pageType,
        page_title: this.dataset.pageTitle,
      },
    }

    window.dataLayer = window.dataLayer || []
    window.dataLayer.push(ga4EventData)
  }

  setClipPath () {
    const width = this.offsetWidth
    const halfWidth = width / 2
    const thickness = window.BAO.MediaBreakpoints.isSm ? 50 : 35
    const outerRadius = halfWidth
    const innerRadius = (width - thickness * 2) / 2

    const clipPath = `path("M 0, ${halfWidth} A ${outerRadius} ${outerRadius} 0 0 1 ${width} ${halfWidth} L ${
      width - thickness
    } ${halfWidth} A ${innerRadius} ${innerRadius} 0 0 0 ${thickness} ${halfWidth} A ${innerRadius} ${innerRadius} 0 0 0 ${
      width - thickness
    } ${halfWidth} L ${width} ${halfWidth} A ${outerRadius} ${outerRadius} 0 0 1 0 ${halfWidth} Z")`

    this.style.setProperty('--Clip_Path', clipPath)
  }
}

if (!customElements.get('product-chart')) {
  customElements.define('product-chart', ProductChart)
}
